export var OSType;
(function (OSType) {
    OSType["iOS"] = "iOS";
    OSType["Android"] = "Android";
})(OSType || (OSType = {}));
export var PlatformType;
(function (PlatformType) {
    PlatformType["Mobile"] = "mobile";
    PlatformType["Desktop"] = "desktop";
    PlatformType["Tablet"] = "tablet";
})(PlatformType || (PlatformType = {}));
export var BrowserType;
(function (BrowserType) {
    BrowserType["Safari"] = "safari";
    BrowserType["Chrome"] = "chrome";
    BrowserType["Others"] = "others";
})(BrowserType || (BrowserType = {}));
export var AppType;
(function (AppType) {
    AppType["Tools"] = "tools";
    AppType["Homepage"] = "homepage";
    AppType["App"] = "app";
})(AppType || (AppType = {}));
export const AllowedEnterpriseCountries = [
    'AU',
    'AT',
    'BE',
    'CA',
    'DK',
    'FI',
    'FR',
    'DE',
    'HK',
    'IN',
    'IL',
    'IT',
    'JP',
    'LU',
    'MY',
    'NL',
    'AN',
    'NZ',
    'NO',
    'OM',
    'PT',
    'SA',
    'SG',
    'ZA',
    'KR',
    'ES',
    'SE',
    'CH',
    'TW',
    'AE',
    'GB',
    'US',
];
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Creator"] = "creator";
    UserRole["Design"] = "design";
    UserRole["Editor"] = "editor";
    UserRole["Root"] = "root";
    UserRole["SuperAdmin"] = "super_admin";
    UserRole["New"] = "new";
})(UserRole || (UserRole = {}));
export const AvatarColorsDS = [
    'iv-bg-orange',
    'iv-bg-red',
    'iv-bg-hot-pink',
    'iv-bg-violet',
    'iv-bg-violet-light',
    'iv-bg-violet-dark',
    'iv-bg-blue',
    'iv-bg-deep-blue',
    'iv-bg-deep-blue-light',
    'iv-bg-deep-blue-dark',
    'iv-bg-green-dark',
    'iv-bg-turquoise',
    'iv-bg-turquoise-light',
    'iv-bg-turquoise-dark',
    'iv-bg-green-dark',
    'iv-bg-green-light',
    'iv-bg-lime-green-light',
    'iv-bg-lime-green-dark',
    'iv-bg-lime-yellow',
];
